import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["checkbox", "title"];

  connect() {
    setTimeout(() => {
      if (!this.hasCheckboxTarget || !this.hasTitleTarget) {
        console.error("Missing checkbox or title field in the modal.");
        return;
      }

      this.toggleTitle(); // Ensure the correct title is set
    }, 100);
  }

  toggleTitle() {
    if (!this.hasCheckboxTarget || !this.hasTitleTarget) {
      console.error("Checkbox or title field is missing in modal.");
      return;
    }

    if (this.checkboxTarget.checked) {
      this.titleTarget.value = this.data.get("title");
    } else {
      this.titleTarget.value = "";
    }
  }
}
